import DOMPurify from 'dompurify';
import { marked } from 'marked';

// Basic markdown to HTML with sanitizer and safe links
export function parseMarkdown(md: string): string {
  if (!md) return '';
  // Render markdown to HTML
  const raw = marked.parse(md, { breaks: true }) as string;

  // Sanitize and enforce safe links
  const clean = DOMPurify.sanitize(raw, {
    USE_PROFILES: { html: true },
    ADD_ATTR: ['target', 'rel'],
  });

  // Post-process links to ensure target and rel are set
  const wrapper = document.createElement('div');
  wrapper.innerHTML = clean;
  const anchors = wrapper.querySelectorAll('a');
  anchors.forEach((a) => {
    a.setAttribute('target', '_blank');
    a.setAttribute('rel', 'noopener noreferrer nofollow');
  });
  return wrapper.innerHTML;
}